import { useTranslation } from 'react-i18next';
import { HStack, View, Box, useTheme } from 'native-base';

import { AlertCircleIcon, Button, Text, ThumbsUpIcon } from '@pimm/base';

type EditStatusConfirmationProps = {
  isAuthorized?: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
  selectedUserCount?: number;
};

export const EditStatusConfirmation = ({ isAuthorized, selectedUserCount, ..._props }: EditStatusConfirmationProps) => {
  const { colors } = useTheme();
  const { t } = useTranslation();

  return (
    <View position="relative" px={6} pt={5} minHeight="200px">
      <HStack alignItems="flex-start" justifyContent="space-between" mb={4}>
        <Box rounded="full" boxSize={12} alignItems="center" justifyContent="center" bg={isAuthorized ? 'blueLight.100' : 'error.100'}>
          {isAuthorized ? <ThumbsUpIcon size={6} color={colors.blueLight[600]} /> : <AlertCircleIcon size={6} color={colors.error[600]} />}
        </Box>
      </HStack>

      <Box mt={2} mb={isAuthorized ? 2 : 3}>
        <Text size="xl" color="gray.900" fontWeight={500} mb={2} lineHeight="sm">
          {isAuthorized ? t('app_insights:update_learner_status') : t('app_insights:permission_denied')}
        </Text>
        <Text size="md" color="gray.600" fontWeight={400} mb={3} lineHeight="md">
          {isAuthorized
            ? `${t('app_insights:update_learner_status_message')} ${selectedUserCount} ${t(
                'app_insights:update_learner_status_message_completed',
              )}\n\n${t('app_insights:cannot_undone')}`
            : t('app_insights:permission_denied_message')}
        </Text>
      </Box>

      {isAuthorized && (
        <HStack space={2} pt={1} pb={5}>
          <Button flex={1} size="lg" variant="unstyled" shadow={0} borderColor="gray.300" bg="white" onPress={_props.onClose}>
            {t('app:cancel')}
          </Button>

          <Button flex={1} size="lg" shadow={0} borderColor="primary.600" onPress={_props.onConfirm}>
            {t('app:confirm')}
          </Button>
        </HStack>
      )}
    </View>
  );
};
